import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/imgs/logos_move.png'


const _hoisted_1 = { id: "move-app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "img",
  alt: ""
}, null, -1)

import { ref } from "vue";
import type { FormInstance } from "vant";
import { Toast } from "vant";
import Title from "../../../components/checkstand/Title.vue";
import Payment from "../../../components/checkstand/Payment.vue";
import BasicInfo from "./BasicInfo.vue";
import BillingAddress from "./BillingAddress.vue";
import CustomButton from "../../../components/checkstand/CustomButton.vue";
import OrderInfo from "../../../components/checkstand/OrderInfo.vue";
import { getOrder } from "../hooks/order";
import { validatePayType } from '@/http/api/checkstand'

interface ChildApi {
  form: FormInstance;
}

interface ErrorMsg {
  message: string;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { order, payment, submit } = getOrder();
const addressVisible = ref(false);

function openAddress(isOpen: boolean) {
  addressVisible.value = isOpen;
}

const basic = ref<ChildApi>();
const address = ref<ChildApi>();

// 校验接口
function validateCardNo() {
  const rawSplitArr = order.payType ? (order.payType as string).split(',') : []
  const cardType = rawSplitArr.length > 1 ? rawSplitArr[1] : rawSplitArr[0]
  const params = {
    cardNo: order.CardNo,
    cardType
  }
  return validatePayType(params)
}
// 错误类型
function failed(errs: ErrorMsg[]) {
  const err = errs[0];
  Toast(`
    Data Verification Failed!
    err: ${err.name}
    msg: ${err.message}
  `);
}

const loading = ref(false)
async function submitForm() {
  try {
    if (!addressVisible.value) {
      await basic.value?.form.validate()
    } else {
      await Promise.all([basic.value?.form.validate(), address.value?.form.validate()])
    }
  } catch (err) {
    failed(err as ErrorMsg[])
    return
  }
  try {
    loading.value = true
    const result = await validateCardNo()
    if (result.status === 500) {
      throw new Error(result.msg)
    }
  } catch (err) {
    Toast((err as Error).message)
    loading.value = false
    return
  }
  try {
    submit()
  } catch (err) {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_CHLoading = _resolveComponent("CHLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Payment, {
      paymentAmount: _unref(payment),
      class: "pay"
    }, null, 8, ["paymentAmount"]),
    _createVNode(Title, {
      text: "Basic Information",
      class: "title"
    }),
    _createVNode(BasicInfo, {
      class: "basic",
      ref_key: "basic",
      ref: basic
    }, null, 512),
    _createVNode(Title, {
      text: "The billing address is the same as the receiving address.",
      class: "title",
      open: "",
      onChangeSwitch: openAddress
    }),
    _withDirectives(_createVNode(BillingAddress, {
      class: "address",
      ref_key: "address",
      ref: address
    }, null, 512), [
      [_vShow, addressVisible.value]
    ]),
    _createVNode(CustomButton, {
      class: "button",
      onClickSubmit: submitForm
    }),
    _createVNode(OrderInfo, {
      "order-no": _unref(order).BillNo
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["order-no"]),
    (loading.value)
      ? (_openBlock(), _createBlock(_component_CHLoading, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})